import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { Text, Container } from '@leroy-merlin-br/backyard-react-ui'

import * as storage from 'scripts/utils/storage'

import { HeaderContext } from 'reactSite/Header/contexts/HeaderContext'

import * as S from './styled'

const LOCAL_STORAGE_KEY = 'employee-notification-dispatched'
const COMPANY_ID_URL = `${
  window.env && window.env.baseHost
}/api/boitata/v1/employee/company-id`

const EmployeeNotification = () => {
  const [showNotification, setShowNotification] = useState(false)
  const { isLogged, userResources } = useContext(HeaderContext)

  const tryShowEmployeeNotification = async () => {
    try {
      const {
        data: { companyId },
        status
      } = await axios.get(COMPANY_ID_URL)

      if (status === 200 && !!parseInt(companyId)) {
        setShowNotification(true)
        storage.set(LOCAL_STORAGE_KEY, true)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (storage.has(LOCAL_STORAGE_KEY) || !isLogged) {
      return
    }

    tryShowEmployeeNotification()
  })

  return (
    showNotification && (
      <S.Wrapper>
        <Container>
          <S.CloseIcon onClick={() => setShowNotification(false)} />

          <Text as="p">Olá, {userResources.name}!</Text>

          <Text noMargin as="p" size="kilo">
            Vimos que trabalha com a gente, por isso você tem direito a
            descontos em nosso site! Esses descontos funcionam da seguinte
            forma: 20% em produtos MDH, 10% nos outros produtos. O desconto de
            colaborador não é aplicado em produtos que já estão em oferta ou que
            não sejam vendidos pela Leroy Merlin.
          </Text>
        </Container>
      </S.Wrapper>
    )
  )
}

export default EmployeeNotification
